import * as React from 'react'

const AddressList = (addressList, selectAddress) =>
    (
        <div className="address__list">
            {addressList.map( (a, i) => (
                    <div 
                        className="address__list__item" 
                        onClick={() => selectAddress(a)} 
                        key={i}
                    >
                        {a.Text}
                    </div>
                ))}
        </div>
    )

export default AddressList


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Address/components/AddressList.tsx